import { SportsDetailState } from "@/pages/sports/hooks/use-sports-detail";

/**
 * The one muted line a child-document section shows when it has nothing to render:
 * loading, a missing document (404), or a failed read. A failure stays inline, so
 * it never blanks the page around it.
 */
export function DetailNotice({
  state,
  what,
  emptyText,
}: {
  state: SportsDetailState<unknown>;
  /** Lowercase noun for the loading and error lines, e.g. "standings". */
  what: string;
  /** The empty line, e.g. "No standings yet". */
  emptyText: string;
}) {
  if (state.status === "empty") {
    return <p className="text-sm text-muted-foreground">{emptyText}</p>;
  }
  if (state.status === "error") {
    return (
      <p role="alert" className="text-sm text-destructive">
        Could not load {what}: {state.message}
      </p>
    );
  }
  if (state.status === "loading") {
    return <p className="text-sm text-muted-foreground">Loading {what}…</p>;
  }
  return null;
}
